import { useRef, useState, useEffect } from "react";
import styles from "./HomePage.module.scss";
import { useTranslation } from "react-i18next";
import Icon1 from "../../imgs/icon1.svg";
import Icon2 from "../../imgs/icon2.svg";
import Icon3 from "../../imgs/icon3.svg";
import Icon5 from "../../imgs/icon5.svg";
import Icon6 from "../../imgs/icon6.svg";
import Icon7 from "../../imgs/icon7.svg";
import Icon8 from "../../imgs/icon8.svg";
import Icon9 from "../../imgs/icon9.jpg";
import Arrow from "../../imgs/arrow.svg";
import Arrow1 from "../../imgs/arrow1.svg";
import Arrow2 from "../../imgs/arrow2.svg";
import Gradient from "../../imgs/gradient.svg";
import Gradient2 from "../../imgs/gradient2.svg";
import Slider from "../../components/Slider.jsx";
import { slides } from "../../components/Slides.jsx";
import Header from "../../components/Header.jsx";
import Footer from "../../components/Footer.jsx";
import Video1 from "../../imgs/video1.mp4";
import Video2 from "../../imgs/video2.mp4";
import { Link, useNavigate } from "react-router-dom";
import Background from "../../imgs/Background.svg";
import Video from "../../imgs/video.png";

export default function HomePage() {
  const { t } = useTranslation();
  const sliderRef = useRef(null);
  const [currentSlide, setCurrentSlide] = useState(1);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [isPlaying, setIsPlaying] = useState(false);
  const navigate = useNavigate();

  const handlePlay = () => {
    setIsPlaying(true);
  };

  const handleSlideChange = (index) => {
    setCurrentSlide(index + 1);
  };

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div className={styles.page}>
      <div className={styles.header}>
        <Header />
        <div className={styles.top}>
          <h1>synergy</h1>
          <span>assets</span>
        </div>
        <div className={styles.bottom}>
          <h1>{t("Your Path to Financial Success")}</h1>
          <span>
            {t(
              "Low minimum deposits, low spreads and additional bonuses when depositing create profitable conditions for trading. And a wide range of payment systems helps to perform financial operations quickly and comfortably."
            )}
          </span>
        </div>
      </div>

      <div className={styles.section1}>
        <div className={styles.bottom}>
          <div className={styles.left_side}>
            <div className={styles.text}>
              <h2 className={styles.h2}>{t("Your Data.")}</h2>
              <h2 className={styles.h2}>
                {t("Your ")}
                <h3>{t("Business")}</h3>
              </h2>
              <span className={styles.footer}>
                {t(
                  "Low minimum deposits, low spreads and additional bonuses when depositing create profitable conditions for trading."
                )}
              </span>
            </div>
            <div className={styles.buttons}>
              <Link to="/login">
                {t("Login")}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                >
                  <path
                    d="M4 4L12 12M12 12L12 6M12 12L6 12"
                    stroke="white"
                    stroke-width="1.5"
                    stroke-linecap="square"
                  />
                </svg>
              </Link>
              <Link to="/register">
                {t("Registration")}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                >
                  <path
                    d="M4 4L12 12M12 12L12 6M12 12L6 12"
                    stroke="white"
                    stroke-width="1.5"
                    stroke-linecap="square"
                  />
                </svg>
              </Link>
            </div>
          </div>
          <div
            className={styles.right_side}
            style={{ position: "relative", width: "100%", height: "696px" }}
          >
            {isPlaying ? (
              <iframe
                width="100%"
                height="696px"
                src="https://www.youtube.com/embed/a5XfQWUUZM8?controls=0&autoplay=1"
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
                referrerPolicy="strict-origin-when-cross-origin"
              ></iframe>
            ) : (
              <div className={styles.video_background}>
                <img src={Gradient} />
                <div className={styles.description}>
                  <p>{t("What is Crypto?")}</p>
                  <span>{t("Binance Academy")}</span>
                </div>
                <div className={styles.play_button} onClick={handlePlay}>
                  {t("Play")}
                </div>
              </div>
            )}
          </div>
        </div>
        <div className={styles.title}>
          <div className={styles.left_side}>
            <p>{t("What we do")}</p>
            <h2>{t("Trade with a professional")}</h2>
          </div>
          <div className={styles.right_side}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="80"
              height="78"
              viewBox="0 0 80 78"
              fill="none"
            >
              <path
                d="M76 1L76.5 1L76.5 0.5L76 0.5V1ZM75.6464 77.3536C75.8417 77.5488 76.1583 77.5488 76.3536 77.3536L79.5355 74.1716C79.7308 73.9763 79.7308 73.6597 79.5355 73.4645C79.3403 73.2692 79.0237 73.2692 78.8284 73.4645L76 76.2929L73.1716 73.4645C72.9763 73.2692 72.6597 73.2692 72.4645 73.4645C72.2692 73.6597 72.2692 73.9763 72.4645 74.1716L75.6464 77.3536ZM75.5 1L75.5 77L76.5 77L76.5 1L75.5 1ZM76 0.5L2.18556e-08 0.5L-2.18558e-08 1.5L76 1.5V0.5Z"
                fill="white"
              />
            </svg>
          </div>
        </div>

        <div className={styles.blocks}>
          <div className={styles.block}>
            <div className={styles.info}>
              <div className={styles.main}>
                <p>{t("Profitability")}</p>
                <span>
                  {t(
                    "Low minimum deposits, low spreads and additional bonuses when depositing create profitable conditions for trading."
                  )}
                  <br />
                  <br />
                  {t(
                    "And a wide range of payment systems helps to perform financial operations quickly and comfortably."
                  )}
                </span>
              </div>
              <div onClick={() => navigate('/login')} className={styles.button}>
                {t("Explore")}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                >
                  <path
                    d="M4 4L12 12M12 12L12 6M12 12L6 12"
                    stroke="white"
                    stroke-width="1.5"
                    stroke-linecap="square"
                  />
                </svg>
              </div>
            </div>
            <div className={styles.number}>01</div>
          </div>
          <div className={styles.block}>
            <div className={styles.info}>
              <div className={styles.main}>
                <p>{t("Technology")}</p>
                <span>
                  {t(
                    "The company's modern equipment helps traders to trade at the high level accepted in the Forex industry."
                  )}
                  <br />
                  <br />
                  {t(
                    "Reliable trading platforms, their mobile versions and fast order execution speed increase profitable opportunities."
                  )}
                </span>
              </div>
              <div onClick={() => navigate('/login')} className={styles.button}>
                {t("Explore")}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                >
                  <path
                    d="M4 4L12 12M12 12L12 6M12 12L6 12"
                    stroke="white"
                    stroke-width="1.5"
                    stroke-linecap="square"
                  />
                </svg>
              </div>
            </div>
            <div className={styles.number}>02</div>
          </div>
          <div className={styles.block}>
            <div className={styles.info}>
              <div className={styles.main}>
                <p>{t("Services")}</p>
                <span>
                  {t(
                    "Since 2008, Synergy Assets has been providing the best services on the market."
                  )}
                  <br />
                  <br />
                  {t(
                    "Modern trading platforms, personal support, training and a wide range of profitable trading assets."
                  )}
                </span>
              </div>
              <div onClick={() => navigate('/login')} className={styles.button}>
                {t("Explore")}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                >
                  <path
                    d="M4 4L12 12M12 12L12 6M12 12L6 12"
                    stroke="white"
                    stroke-width="1.5"
                    stroke-linecap="square"
                  />
                </svg>
              </div>
            </div>
            <div className={styles.number}>03</div>
          </div>
        </div>
      </div>

      <div className={styles.section2}>
        <div className={styles.mission}>
          <div className={styles.top}>
            <h1>{t("Our Mission")}</h1>
            <div className={styles.subtitle}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="78"
                height="80"
                viewBox="0 0 78 80"
                fill="none"
              >
                <path
                  d="M1 76V76.5H0.5V76L1 76ZM77.3536 75.6464C77.5488 75.8417 77.5488 76.1583 77.3536 76.3536L74.1716 79.5355C73.9763 79.7308 73.6597 79.7308 73.4645 79.5355C73.2692 79.3403 73.2692 79.0237 73.4645 78.8284L76.2929 76L73.4645 73.1716C73.2692 72.9763 73.2692 72.6597 73.4645 72.4645C73.6597 72.2692 73.9763 72.2692 74.1716 72.4645L77.3536 75.6464ZM1 75.5H77V76.5H1V75.5ZM0.5 76L0.500003 0H1.5L1.5 76L0.5 76Z"
                  fill="white"
                />
              </svg>
              <p>
                {t(
                  "The company's modern equipment helps traders to trade at the high level accepted in the Forex industry."
                )}
                <br />
                <br />
                {t(
                  "Reliable trading platforms, their mobile versions and fast order execution speed increase profitable opportunities."
                )}
              </p>
            </div>
          </div>
          <div className={styles.bottom}>
            <p>
              {t("synergy")} | <span>{t(" assets")}</span>
            </p>
            <div onClick={() => navigate('/login')} className={styles.button}>
              {t("Read more about us")}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="17"
                height="16"
                viewBox="0 0 17 16"
                fill="none"
              >
                <path
                  d="M4.5 4L12.5 12M12.5 12L12.5 6M12.5 12L6.5 12"
                  stroke="white"
                  stroke-width="1.5"
                  stroke-linecap="square"
                />
              </svg>
            </div>
          </div>
        </div>
        <div className={styles.title}>
          <div className={styles.left_side}>
            <p>{t("Our capabilities")}</p>
            <h2>{t("Advantages of Online Platform")}</h2>
          </div>
          <div className={styles.right_side}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="80"
              height="78"
              viewBox="0 0 80 78"
              fill="none"
            >
              <path
                d="M76 1L76.5 1L76.5 0.5L76 0.5V1ZM75.6464 77.3536C75.8417 77.5488 76.1583 77.5488 76.3536 77.3536L79.5355 74.1716C79.7308 73.9763 79.7308 73.6597 79.5355 73.4645C79.3403 73.2692 79.0237 73.2692 78.8284 73.4645L76 76.2929L73.1716 73.4645C72.9763 73.2692 72.6597 73.2692 72.4645 73.4645C72.2692 73.6597 72.2692 73.9763 72.4645 74.1716L75.6464 77.3536ZM75.5 1L75.5 77L76.5 77L76.5 1L75.5 1ZM76 0.5L2.18556e-08 0.5L-2.18558e-08 1.5L76 1.5V0.5Z"
                fill="white"
              />
            </svg>
          </div>
        </div>
        <div className={styles.blocks}>
          <div className={styles.block}>
            <div className={styles.image_container}>
              <img src={Icon5} alt="icon" />
            </div>
            <p>{t("Wide range of instruments")}</p>
            <span>
              {t(
                "Over 170 high-yielding assets, including the most popular stocks and indices, precious metals, energy and cryptocurrencies."
              )}
            </span>
          </div>
          <div className={styles.block}>
            <div className={styles.image_container}>
              <img src={Icon6} alt="icon" />
            </div>
            <p>{t("Timely risk management")}</p>
            <span>
              {t(
                "Capture profits and limit potential losses in time by setting Stop Loss and Take Profit right on the chart."
              )}
            </span>
          </div>
          <div className={styles.block}>
            <div className={styles.image_container}>
              <img src={Icon7} alt="icon" />
            </div>
            <p>{t("All operations are supervised")}</p>
            <span>
              {t(
                "The ability to manage open and closed trades, work with limit orders, as well as view the history of all trades for each selected instrument."
              )}
            </span>
          </div>
          <div className={styles.block}>
            <div className={styles.image_container}>
              <img src={Icon8} alt="icon" />
            </div>
            <p>{t("Best Trading Solutions")}</p>
            <span>
              {t(
                "The Autochartist technical advisor built into the platform opens up even more profitable opportunities."
              )}
            </span>
          </div>
        </div>
      </div>

      <div className={styles.section3}>
        <div className={styles.footer}>
          {/* <div className={styles.buttons}>
            {windowWidth > 1300 ? (
              <>
                <span>
                  {currentSlide} / {slides.length}
                </span>
                <button onClick={() => sliderRef.current?.slidePrev()}>
                  <img src={Arrow1} alt="arrow" />
                </button>
                <button onClick={() => sliderRef.current?.slideNext()}>
                  <img src={Arrow2} alt="arrow" />
                </button>
              </>
            ) : (
              <>
                <button onClick={() => sliderRef.current?.slidePrev()}>
                  <img src={Arrow1} alt="arrow" />
                </button>
                <span>
                  {currentSlide} / {slides.length}
                </span>
                <button onClick={() => sliderRef.current?.slideNext()}>
                  <img src={Arrow2} alt="arrow" />
                </button>
              </>
            )}
          </div> */}
        </div>
        <Slider ref={sliderRef} onSlideChange={handleSlideChange} />
      </div>

      <Footer />
    </div>
  );
}
